/**
 * Toggle class on a target element when clicked
 * @param el
 */

function ToggleClass(el) {
    var targetSelector = el.getAttribute('data-toggle-class-target');

    this.target = document.querySelector(targetSelector);

    if (! this.target) {
        this.target = document.documentElement;
    }
    this.className = el.getAttribute('data-toggle-class');
    el.addEventListener('click', this.click.bind(this));
};

ToggleClass.prototype.click = function () {
    this.target.classList.toggle(this.className);
};

module.exports = ToggleClass;